import { render, staticRenderFns } from "./TestFoodcardModal.vue?vue&type=template&id=5917c8a7"
import script from "./TestFoodcardModal.vue?vue&type=script&lang=ts"
export * from "./TestFoodcardModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports